import CoreBase from '../../../../services/engines/CoreBase';
import logService from '../../../../services/wss/logService3';
import groupNodeCache from '../Engines/GroupNodeCache';

const _name = 'OnEntryNodesResolvedHandler';

/**
 * Handles the OnEntryNodesResolved SignalR event.
 * Removes entry from all nodes, then adds it to the resolved nodes.
 * Only dependency is GroupNodeCache — fully testable in isolation.
 */
export default class OnEntryNodesResolvedHandler extends CoreBase {
    handle = (data) => {
        try {
            if (!data?.entry?.rk) {
                logService.logError(`${_name}.handle: Invalid entry.rk`);
                return false;
            }

            // remove entry from any node it was include
            groupNodeCache.removeFromAllNodes(data.entry.rk);

            // add entry to new resolved node
            data.nodes.forEach((k) => groupNodeCache.addOrUpdate(k, data.entry));

            // update node totals for NoteHeader dropdown
            data.nodeData.forEach((x) => groupNodeCache.updateTotal(x.nid, x.total));

            return true;
        } catch (error) {
            logService.logError(`${_name}.handle: ${error.message}`);
            return false;
        }
    };
}
